module.exports = __webpack_public_path__ + "img/video@2x.0fa6454.jpg";